<template>
  <v-container fluid style="background-color: transparent" class="pa-0">
    <v-container style="background-color: transparent !important">
      <v-row dense class="mt-4">
        <v-col cols="auto">
          <gradient-bar />
          <h6 class="primary clipedText mt-2" style="font-size: 19.2px">
            Planos
          </h6>
        </v-col>
      </v-row>

      <v-row
        dense
        align="center"
        style="background-color: transparent !important"
      >
        <v-col
          cols="12"
          md="7"
          sm="12"
          class="slide-left-to-right"
          style="background-color: transparent !important"
        >
          <v-row no-gutters>
            <h3 class="clipedText primary headerText mb-2">
              Estude como quiser
            </h3>
          </v-row>
          <v-row no-gutters class="mb-4">
            <span class="poppins">
              Você é quem decide a
              <strong
                >modalidade e frequência das aulas. Você tem a liberdade e a
                flexibilidade de falar inglês no ritmo que desejar.</strong
              >
            </span>
          </v-row>
          <v-row no-gutters>
            <span class="poppins">
              Monte o plano que mais se adeque aos seus objetivos! Enquanto em
              cursos tradicionais você pode alcançar fluência no Inglês em até 7
              anos, na Pitch você <strong>agiliza o processo</strong> e pode
              alcançar essa meta<strong> até 70% mais rápido.</strong>
            </span>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          md="5"
          sm="12"
          class="slide-right-to-left d-flex justify-center"
          style="background-color: transparent !important"
        >
          <div
            ref="animationContainer"
            style="
              width: 100%;
              max-width: 350px;
              height: 300px;
              background-color: transparent;
            "
          ></div>
        </v-col>
      </v-row>

      <v-row
        dense
        class="mt-4 slide-bottom-to-top"
        style="background-color: transparent !important"
      >
        <v-col cols="12" md="7">
          <div class="mb-4">
            <p class="bolder mb-2">Nível:</p>
            <div class="d-flex flex-wrap gap-2">
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                class="mr-2 mb-2"
                :class="{
                  primary: level === 'beginner',
                  selected: level === 'beginner',
                }"
                @click="setLevel('beginner')"
                >Iniciante</v-btn
              >
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                class="mr-2 mb-2"
                :class="{
                  primary: level === 'average',
                  selected: level === 'average',
                }"
                @click="setLevel('average')"
                >Intermediário</v-btn
              >
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                class="mb-2"
                :class="{
                  primary: level === 'advanced',
                  selected: level === 'advanced',
                }"
                @click="setLevel('advanced')"
                >Avançado</v-btn
              >
            </div>
          </div>

          <div class="mb-4">
            <p class="bolder mb-2">Modalidade:</p>
            <div class="d-flex flex-wrap gap-2">
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                class="mr-2 mb-2"
                :class="{
                  primary: format === 'individual',
                  selected: format === 'individual',
                }"
                :disabled="level === null"
                @click="setFormat('individual')"
                >Individual</v-btn
              >
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                class="mr-2 mb-2"
                :class="{
                  primary: format === 'duo',
                  selected: format === 'duo',
                }"
                :disabled="level === null"
                @click="setFormat('duo')"
                >Dupla</v-btn
              >
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                class="mr-2 mb-2"
                :class="{
                  primary: format === 'trio',
                  selected: format === 'trio',
                }"
                :disabled="level === null"
                @click="setFormat('trio')"
                >Trio</v-btn
              >
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                class="mr-2 mb-2"
                :class="{
                  primary: format === 'squad',
                  selected: format === 'squad',
                }"
                :disabled="level === null"
                @click="setFormat('squad')"
                >Quarteto</v-btn
              >
            </div>
          </div>

          <div class="mb-4">
            <p class="bolder mb-2">Frequência:</p>
            <div class="d-flex flex-wrap gap-2">
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                class="mr-2"
                :class="{
                  primary: frequency === '1',
                  selected: frequency === '1',
                }"
                :disabled="time === null || format === 'by_myself'"
                @click="setFrequency('1')"
                >x1 na semana</v-btn
              >
              <v-btn
                rounded
                outlined
                elevation="2"
                small
                :class="{
                  primary: frequency === '2',
                  selected: frequency === '2',
                }"
                :disabled="time === null || format === 'by_myself'"
                @click="setFrequency('2')"
                >x2 na semana</v-btn
              >
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="5" class="d-flex align-center">
          <v-card
            flat
            color="transparent"
            width="100%"
            class="pa-4"
            style="border: 1px solid rgba(0, 0, 0, 0.05); border-radius: 16px"
          >
            <div ref="priceCard">
              <v-row
                no-gutters
                align="center"
                class="mb-4"
                v-if="!isIndividual && estimatedPeriod"
              >
                <h5 class="ml-2">Duração estimada {{ estimatedPeriod }}</h5>
              </v-row>

              <v-btn
                block
                rounded
                outlined
                color="primary"
                :disabled="price === 0"
                class="text-none mb-4 font-weight-bold"
                @click="openConversation"
              >
                👉 Conecte-se ao professor ideal
              </v-btn>

              <v-divider class="mb-4"></v-divider>
              <p class="bolder mb-2">Benefícios</p>

              <div
                v-for="(beneficio, index) in isIndividual
                  ? beneficiosIndiv
                  : beneficiosGrupo"
                :key="index"
                class="d-flex align-center mb-1"
              >
                <v-icon color="primary" small>mdi-check-circle-outline</v-icon>
                <span class="ml-2 body-2">{{ beneficio }}</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import lottie from "lottie-web";
const animationData = require("@/assets/animations/plans/learning.json");

export default {
  name: "PlansSection",
  data() {
    return {
      level: null,
      format: null,
      time: null,
      frequency: null,
      price: 0.0,
      disabledCard: true,
      estimatedPeriod: null,
      isIndividual: false,
      beneficiosGrupo: [
        "Material",
        "Aulas de conversasão",
        "Aplicativo",
        "Vídeo aulas",
      ],
      beneficiosIndiv: [
        "App",
        "Plataforma de estudos",
        "Vídeo aulas",
        "Eventos",
        "Guia de estudos",
        "Monitorias",
      ],
    };
  },
  computed: {
    downloadButton() {
      return this.disabledCard
        ? require("@/assets/icons/download.svg")
        : require("@/assets/icons/download_pink.svg");
    },
  },
  // ... (restante do seu script e métodos permanecem idênticos)
  watch: {
    frequency(value) {
      if (value && this.level && this.format && this.time) {
        this.calculatePrice();
        this.disabledCard = false;
        this.estimatedPeriod = this.setDutation();
      }
    },
    format() {
      this.calculatePrice();
      this.estimatedPeriod = this.setDutation();
    },
    time() {
      this.calculatePrice();
      this.estimatedPeriod = this.setDutation();
    },
    price() {
      if (this.$vuetify.breakpoint.xsOnly) {
        // Ajustado para scroll suave sem vh
      }
    },
  },
  mounted() {
    lottie.loadAnimation({
      container: this.$refs.animationContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData,
    });
  },
  methods: {
    setLevel(level) {
      this.level = level;
      if (this.format) {
        this.estimatedPeriod = this.setDutation();
      }
    },
    setFormat(format) {
      if (format === "by_myself") {
        this.time = null;
        this.frequency = null;
      }
      this.format = format;
      this.time = "1h";
    },

    setTime(time) {
      this.isIndividual = false;
      this.time = time;
    },
    setFrequency(frequency) {
      this.frequency = frequency;
    },
    download() {
      window.open(process.env.VUE_APP_PITCH_EMENTA, "_blank");
    },
    openConversation() {
      window.open(
        "https://forms.clickup.com/3118765/f/2z5nd-7833/PVZ6XREQVLDC4EXCP7",
        "_blank"
      );
    },
    calculatePrice() {
      if (this.format === "by_myself") {
        this.disabledCard = false;
        this.setPrice(79.9);
        this.isIndividual = true;
      } else if (this.format && this.time && this.frequency && this.level) {
        this.isIndividual = false;
        switch (this.time) {
          case "1h":
            switch (this.format) {
              case "individual":
                if (this.frequency === "1") this.setPrice(263.9);
                else this.setPrice(527.9);
                break;
              case "duo":
                if (this.frequency === "1") this.setPrice(173.9);
                else this.setPrice(257.9);
                break;
              case "trio":
                if (this.frequency === "1") this.setPrice(143.9);
                else this.setPrice(247.9);
                break;
              case "squad":
                if (this.frequency === "1") this.setPrice(123.9);
                else this.setPrice(207.9);
                break;
            }
            break;
        }
      }
    },
    setPrice(value) {
      this.price = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    setDutation() {
      if (!this.level || !this.format || !this.frequency) return null;
      switch (this.level) {
        case "beginner":
          switch (this.format) {
            case "individual":
              if (this.frequency === "1") return "3.0 - 3.5 anos.";
              else return "1.5 - 2.0 anos.";
            case "duo":
              if (this.frequency === "1") return "3.5 - 4.5 anos.";
              else return "2.0 - 2.5 anos.";
            case "trio":
              if (this.frequency === "1") return "4.5 - 5.5 anos.";
              else return "2.5 - 3.0 anos.";
            case "squad":
              if (this.frequency === "1") return "5.5 - 6.5 anos.";
              else return "3.0 - 3.5 anos.";
          }
          break;
        case "average":
          switch (this.format) {
            case "individual":
              if (this.frequency === "1") return "2.0 - 2.5 anos.";
              else return "1.0 - 1.5 anos.";
            case "duo":
              if (this.frequency === "1") return "2.0 - 3.5 anos.";
              else return "1.0 - 2.0 anos.";
            case "trio":
              if (this.frequency === "1") return "2.5 - 4.0 anos.";
              else return "1.5 - 2.0 anos.";
            case "squad":
              if (this.frequency === "1") return "3.5 - 5.0 anos.";
              else return "1.5 - 2.0 anos.";
          }
          break;
        case "advanced":
          switch (this.format) {
            case "individual":
              if (this.frequency === "1") return "1.0 - 1.5 anos.";
              else return "0.5 - 1.0 anos.";
            case "duo":
              if (this.frequency === "1") return "1.0 - 2.0 anos.";
              else return "0.5 - 1.0 anos.";
            case "trio":
              if (this.frequency === "1") return "1.5 - 2.5 anos.";
              else return "1.0 - 1.5 anos.";
            case "squad":
              if (this.frequency === "1") return "2.0 - 3.0 anos.";
              else return "1.0 - 1.5 anos.";
          }
          break;
      }
      return "";
    },
  },
};
</script>

<style scoped>
.headerText {
  font-size: clamp(
    32px,
    5vw,
    45px
  ); /* Fonte responsiva que não quebra no zoom */
  font-weight: 800;
}
.clipedText {
  background: linear-gradient(90deg, #9923cd, #e8276f);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.poppins {
  font-family: "Poppins", sans-serif;
  color: #5f5f61;
}
.bolder {
  font-weight: 700;
  color: #333;
}
.selected {
  color: white !important;
}
.gap-2 {
  gap: 8px;
}
</style>
